// import external dependencies
import "jquery";
import "openseadragon";

// Import everything from autoload
;

// import local dependencies
import Router from "./util/Router";
import common from "./routes/common";
import home from "./routes/home";
import templateAboutUs from "./routes/templateAboutUs";
import exercise from "./routes/exercise";

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  templateAboutUs,
  // prettier-ignore
  'singleExercise': exercise,
});

function speakOnce(e) {
  //if its not click or Enter return
  if (e.keyCode && e.keyCode !== 13) {
    return;
  }
  const element = e.currentTarget;
  const isActive = element.classList.contains("active");
  const isLoading = !!document.querySelector(".loading");
  if (isLoading) return;

  //clicked elements id
  const data_id = element.attributes["data-id"].value;

  const textElement = document.querySelector(`[data-speech=${data_id}]`);
  if (!textElement) {
    if (responsiveVoice.isPlaying()) {
      responsiveVoice.cancel();
    }
    document
      .querySelectorAll(".active")
      .forEach((item) => item.classList.remove("active"));
    document
      .querySelectorAll(".loading")
      .forEach((item) => item.classList.remove("loading"));
    return;
  }

  const text = textElement.getAttribute("data-speech-text");

  if (responsiveVoice.isPlaying()) {
    responsiveVoice.cancel();
    document
      .querySelectorAll(".active")
      .forEach((item) => item.classList.remove("active"));
    if (isActive) {
      return;
    }
  }

  element.classList.add("loading");

  setTimeout(
    () =>
      responsiveVoice.speak(text, "Deutsch Female", {
        pitch: 1,
        rate: 1,
        onstart: () => {
          element.classList.remove("loading");
          element.classList.add("active");
        },
        onend: () => {
          element.classList.remove("active");
        },
      }),
    10
  );
}

//add click event to all audio links
let audioLinks = Array.from(document.querySelectorAll(".audioversion_wrapper"));
audioLinks.forEach((button) => {
  button.addEventListener("keydown", speakOnce);
  button.addEventListener("click", speakOnce);
});

function toggleExercise(e) {
  const number = e.target.attributes["data-key"].value;
  const iframe = document.querySelector(`[data-exercise-iframe='${number}']`);
  if (iframe) {
    iframe.classList.add("active-exercise");
  }
}

const h5pButtons = document.querySelectorAll(".basic-education-single_button");
h5pButtons.forEach((button) => {
  button.addEventListener("click", toggleExercise);
  //remove onclick
  button.addEventListener("click", (e) => e.target.remove());
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js